import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'remove-add-applicant-dialog',
  templateUrl: './remove-applicant-dialog.component.html',
  styleUrls: ['./remove-applicant-dialog.component.css']
})
export class RemoveApplicantDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }
}
